/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* Accedo Build XDK Core (@accedo/xdk-core) 4.2.6
* 
*******************************************************************************/
import isArray from"./isArray";import isPlainObject from"./isPlainObject";import isUndefined from"./isUndefined";const extend=function(i,e,r){let n,t,s,a;for(var d in e)t=i[d],s=e[d],i!==s&&(n=isArray(s),r&&s&&(n||isPlainObject(s))?(n?(n=!1,a=t&&isArray(t)?t:[]):a=t&&isPlainObject(e)?t:{},i[d]=extend(a,s,!0)):isUndefined(s)||(i[d]=s));return i};export default extend;